import UniqueSection from './UniqueSection';
export default UniqueSection;
